import React from 'react';
import UserListLayer from './UserListLayer';

const EmailGroupLayer = () => {
  return <UserListLayer mode='emailGroups' />;
};

export default EmailGroupLayer;
